// import React from "react";
// import "../css/TransparentButton.css"; // Import the custom styles


// const TransparentButton = ({ texts = "Button 49" }) => {
//   return (
//     <button className="button-50" role="button">
//       {texts}
//     </button>
//   );
// };

// export default TransparentButton;

import React from "react";
import ButtonImageTrans from "../assets/Button-Trans.png"; 
import { div } from "framer-motion/client";

const TransparentButton = ({ texts, onClick }) => {
  return (
    <div>
<button
      className="w-[150px] h-[70px] sm:w-[280px] text-xs sm:text-base sm:h-[90px] bg-no-repeat bg-center bg-contain flex items-center justify-center text-white font-bold z-999 relative pb-2"
      style={{ backgroundImage: `url(${ButtonImageTrans})` }}
      onClick={onClick}
    >
      {texts}
    </button>
    </div>
    
  );
};

export default TransparentButton;

